import { Spinner } from 'components/Loader'
import { RenderIcon } from 'features/home/components/HomeDevices/Device/components/RenderIcon'
import { memo, ReactNode } from 'react'

import theme from 'theme_'
import {
  HomeStatusStatusContainer,
  StatusIconContainer,
  ConfigurableCard,
  ConfigurableCardTitile,
  ConfigurableCardLabel,
  ConfigurableLabelSymbol,
} from '../styles'

interface HomeConfigurableCardProps {
  title: string
  label: ReactNode | string
  iconPath?: ReactNode | string
  labelSymbol?: string
  cardColor?: string
  labelColor?: string
  iconColor?: string
  width?: string
  hideOnDesktop?: boolean
  isLoading?: boolean
}

function HomeConfigurableCard({
  title,
  label,
  iconPath,
  labelSymbol,
  cardColor = theme.colors.lighterGrey,
  labelColor = theme.colors.duneWarmGrey,
  iconColor = theme.colors.horizonOrange,
  width,
  isLoading = false,
}: HomeConfigurableCardProps) {
  return (
    <ConfigurableCard color={cardColor} width={width} isLoading={isLoading}>
      {isLoading ? (
        <Spinner size={2} />
      ) : (
        <>
          <HomeStatusStatusContainer>
            <ConfigurableCardTitile>{title}</ConfigurableCardTitile>
            <ConfigurableCardLabel color={labelColor}>
              {label}
              <ConfigurableLabelSymbol>{labelSymbol}</ConfigurableLabelSymbol>
            </ConfigurableCardLabel>
          </HomeStatusStatusContainer>
          <StatusIconContainer>
            <RenderIcon color={iconColor}>{iconPath}</RenderIcon>
          </StatusIconContainer>
        </>
      )}
    </ConfigurableCard>
  )
}

export default memo(HomeConfigurableCard)
